import { render, staticRenderFns } from "./FrzTonsInDay.vue?vue&type=template&id=feb22ad2"
import script from "./FrzTonsInDay.vue?vue&type=script&lang=js"
export * from "./FrzTonsInDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports